const featureFlags = {
    AD_CREATE_ENABLED: true,
    AD_LANDING_PAGE_SCREENSHOT_QUEUE_ENABLED: false,
    ALGOLIA_ADS_INDEX: 'staging_ADS',
    ALGOLIA_ADS_QUERY_SUGGESTIONS_INDEX: 'staging_ADS_query_suggestions',
    ALGOLIA_APP_ID: 'PK8QF2SL4E',
    ALGOLIA_SEARCH_API_KEY: 'df3ad8b9f662f241c1cbda88aa11910f',
    ASSETS_UI: true,
    AZURE_CDN_URL: 'https://cdn.magicbrief.com',
    AZURE_STORAGE_ACCOUNT_NAME: 'magicbriefstorage',
    AZURE_STORAGE_CONNECTION_STRING: 'unset',
    AZURE_STORAGE_SCREENSHOTS_CONTAINER: 'unset',
    AZURE_STORAGE_USER_ASSET_CONTAINER: 'staging-userassets',
    BRAND_TRACKING_MODAL: true,
    COMMENTS_COUNT: true,
    COMMENTS_HYDRATE_RELATIONSHIPS: true,
    DISCOVER_PILLS: true,
    FACEBOOK_API_VERSION: 'v18.0',
    FACEBOOK_APP_ID: '1548574282349689',
    FACEBOOK_APP_LOGIN_CONFIG_ID: '345128978470471',
    FACEBOOK_CONNECT_ENABLED: true,
    FIREBASE_CLIENT_EMAIL: 'firebase-adminsdk-32rgu@magicbrief-beta.iam.gserviceaccount.com',
    FIREBASE_PROJECT_ID: 'magicbrief-beta',
    FOR_YOU_PAGE: true,
    GTM_CONTAINER_ID: 'GTM-PDGN84FW',
    HOCUSPOCUS_PATH: '/ws2',
    INSIGHTS_UI_ENABLED: false,
    INTERCOM_APP_ID: 'rkw2wymi',
    JOB_AD_SEARCH_INGESTOR_ENABLED: true,
    JOB_AD_SEARCH_INGESTOR_SCHEDULE: '*/30 * * * *',
    JOB_FACEBOOK_DATA_CONVERTER_ENABLED: true,
    JOB_FACEBOOK_DATA_CONVERTER_SCHEDULE: '5 */12 * * *',
    JOB_FACEBOOK_INTEGRATION_AD_INGESTOR_ENABLED: true,
    JOB_FACEBOOK_INTEGRATION_AD_INGESTOR_SCHEDULE: '* */12 * * *',
    JOB_RELAY_NOTIFICATIONS_RELAY_ENABLED: true,
    JOB_RELAY_NOTIFICATIONS_RELAY_SCHEDULE_SECONDS: 30,
    LANGUAGE_FILTER: false,
    MAGICAI_VERSION: 'no version provided',
    MAGICBRIEF_PRO_PRICE: 'price_1MTvsjEWwTv5JS3xJRDIrSUh',
    MAGICBRIEF_SEAT_PRICE: 'price_1NceJbEWwTv5JS3x7W8O7MX3',
    MAIL_SERVICE_AUTH_USER: 'api',
    MAIL_SERVICE_FROM: 'donotreply@magicbrief.com',
    MAIL_SERVICE_HOST: 'live.smtp.mailtrap.io',
    MAIL_SERVICE_PORT: 587,
    MAILTRAP_SENDER_EMAIL: 'noreply@magicbrief.com',
    MAILTRAP_SENDER_NAME: 'MagicBrief',
    MAILTRAP_TEMPLATE_UUID_BRIEF_INVITE: 'f6160a4f-4ba9-4427-9b66-5580a3c86ff7',
    MAILTRAP_TEMPLATE_UUID_BRIEF_ASSIGNED_UPDATE: 'fa25fd39-4f91-449e-b129-eaf63566cc83',
    MAILTRAP_TEMPLATE_UUID_BRIEF_DUE_DATE_UPDATE: '2844a4a6-9374-4032-bccb-c29d027e23e6',
    MAILTRAP_TEMPLATE_UUID_BRIEF_STAGE_UPDATE: 'e4204a97-f97a-43de-95ee-30fd13e78d0c',
    MAILTRAP_TEMPLATE_UUID_BRIEF_STATUS_UPDATE: 'db4f345c-d77f-4d8c-98ed-0be5d9cdac01',
    MAILTRAP_TEMPLATE_UUID_COMMENT_MENTION: '5a69e27a-bf0e-4a9f-8ea0-e77f3f648f94',
    MAILTRAP_TEMPLATE_UUID_ORGANISATION_INVITE: '9a9891b0-af26-494f-beb6-a8dcca4004ba',
    MB_API_URL: 'https://mb-staging-api.magicbrief.com',
    MB_CLIENT_URL: 'https://staging.magicbrief.com',
    MB_SHARE_URL: 'https://staging-share.magicbrief.com',
    NOTIFICATIONS_EMAIL: true,
    NOTIFICATIONS_IN_APP: true,
    OPENAI_TOKEN: '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',
    PRESENCES: false,
    REDIS_DB: 10,
    REDIS_HOST: 'mb-staging.redis.cache.windows.net',
    REDIS_PORT: 6380,
    RELAY_NOTIFICATIONS_START_DATE: new Date(2023, 10, 27, 0, 0, 0, 0),
    RELAY_NOTIFICATIONS_STRATEGY: 'scheduled',
    SCREENSHOT_FUNCTION_URL: 'https://mb-staging-functions.azurewebsites.net/api/screenshot',
    SEARCH_ENGINE: 'algolia',
    SEARCH_VERSION: 'v2',
    SENTRY_DSN_API: 'https://896fe9cfca299fd94a9dd97c35b74d3a@o4504063794348032.ingest.sentry.io/4504063806406657',
    SENTRY_DSN_FUNCTIONS: 'https://ce314ee22c9a5b8cde4247988e858de5@o4504063794348032.ingest.sentry.io/4506057105997824',
    SENTRY_DSN_JOBS: 'https://6118c9e5603f39053b692e0a34cb8424@o4504063794348032.ingest.sentry.io/4506193515184128',
    SERVER_PORT: 8000,
    SHORT_URL: 'https://staging.magicbrief.com',
    SHOW_GPT_BOARDS: true,
    SLACK_WEBHOOK_URL: 'https://hooks.slack.com/services/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',
    SLACK_DEBUG_URL: 'https://hooks.slack.com/services/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',
    SOCKET_IO_PATH: '/ws1',
    TIER_ONE_PRICE_PLAN: 'price_1MTvruEWwTv5JS3x95PrSxXW',
    TIER_TWO_PRICE_PLAN: 'price_1MTvsjEWwTv5JS3xJRDIrSUh',
    USER_HYDRATE_HAS_QUALIFIED_EMAIL: true,
};
export default featureFlags;
//# sourceMappingURL=staging.js.map